import React, { Component } from 'react';
import cn from 'classnames';
import { Form, FormGroup, Input, Label, Button } from 'reactstrap';
import Select from 'react-select';
import { isURL } from 'validator';
import { FormattedMessage } from 'react-intl';
import { array } from 'prop-types';

class AddSourceForm extends Component {
  static propTypes = {
    types: array.isRequired,
  };

  state = {
    data: {
      type: 0,
      title: '',
      url: '',
      stat_url: '',
      hits: '',
      subscribers: '',
    },
    loading: false,
    errors: {},
  };

  onChange = (data) => {
    if (data.value) {
      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          type: data.value,
        },
      }));
    } else {
      const { target } = data;
      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          [target.name]: target.value,
        },
      }));
    }
  };

  onSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate(this.state.data);
    this.setState(() => ({ errors }));

    if (Object.keys(errors).length === 0) {
      this.setState(() => ({ loading: true }));
      this.props.submit(this.state.data);
    }
  };

  validate = (data) => {
    const errors = {};

    if (!data.title) {
      errors.title = 'This field is required';
    }

    if ([1, 3, 4].indexOf(data.type) >= 0) {
      if (!isURL(data.url)) {
        errors.url = 'Invalid URL';
      }
    }

    return errors;
  };

  render() {
    const { type, title, url, stat_url, hits, subscribers } = this.state.data;
    const { errors } = this.state;
    const { types, theme } = this.props;

    return (
      <Form onSubmit={this.onSubmit} autoComplete="off">
        <FormGroup className="form-group-upper-label">
          <Label htmlFor="source-type">
            <FormattedMessage id="main.type" defaultMessage="Type" />
          </Label>

          <Select
            id="source-type"
            name="source-type"
            clearable={false}
            value={type}
            placeholder={
              <FormattedMessage id="source.form.type-placeholder" defaultMessage="Choose type" />
            }
            onChange={this.onChange}
            options={types.map((type) => ({
              value: type.id,
              label: type.title,
            }))}
          />
        </FormGroup>

        <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.title })}>
          <Label for="source-title">
            <FormattedMessage id="source.form.title" defaultMessage="Title" />
          </Label>
          <Input
            id="source-title"
            type="text"
            name="title"
            value={title}
            onChange={this.onChange}
            required
          />
          {errors.title && <small className="form-text">{errors.title}</small>}
        </FormGroup>

        {[1, 3, 4].indexOf(type) > -1 && (
          <FormGroup className={errors.url ? 'has-error' : ''}>
            <Label for="source-url">URL</Label>
            <Input
              id="source-url"
              type="url"
              name="url"
              value={url}
              onChange={this.onChange}
              placeholder="http://example.com"
            />
            {errors.url && <small className="form-text">{errors.url}</small>}
          </FormGroup>
        )}

        {[1, 4].indexOf(type) > -1 && (
          <FormGroup>
            <Label for="source-stats-url">
              <FormattedMessage id="source.form.statistics-url" defaultMessage="Statistic URL" />
            </Label>
            <Input
              id="source-stats-url"
              type="url"
              name="stat_url"
              value={stat_url}
              onChange={this.onChange}
              placeholder="https://www.liveinternet.ru/stat/example.com"
            />
          </FormGroup>
        )}

        {[1, 4].indexOf(type) > -1 && (
          <FormGroup>
            <Label for="source-hits">
              <FormattedMessage id="source.form.hits" defaultMessage="Hits" />
            </Label>
            <Input
              id="source-hits"
              name="hits"
              value={hits}
              onChange={this.onChange}
              placeholder="1400"
            />
          </FormGroup>
        )}

        {type === 3 && (
          <FormGroup>
            <Label for="source-subscribers">
              <FormattedMessage id="source.form.subscribers" defaultMessage="Subscribers" />
            </Label>
            <Input
              id="source-subscribers"
              name="subscribers"
              value={subscribers}
              onChange={this.onChange}
              placeholder="1500"
            />
          </FormGroup>
        )}
        <div className="buttons">
          <Button onClick={() => this.props.onCancel()}>
            <FormattedMessage id="sources.modal.cancel" defaultMessage="Cancel" />
          </Button>
          <Button color="primary" disabled={!title || type === 0}>
            <FormattedMessage id="source.buttons.create-source" defaultMessage="Create Source" />
          </Button>
        </div>
      </Form>
    );
  }
}

export default AddSourceForm;
